// Yes/No questions are backed by `Boolean` fields; the API reads their answers as 'true' / 'false'.
export const booleanQuestionOptions = [
	{ value: 'true', label: 'Yes' },
	{ value: 'false', label: 'No' },
];
